export default __webpack_public_path__ + "static/media/SC-PM250GN-Product_ImageGlobal_3.896bded8.jpg";